import { useTranslations } from '@vocab/react';
import {
  Box,
  Inline,
  Secondary,
  Stack,
  Strong,
  Text,
} from 'braid-design-system';

import translations from './.vocab';

export const ViewsSection = ({ viewCount }: { viewCount: number }) => {
  const { t } = useTranslations(translations);

  return (
    <Stack space="small">
      <Text size="xsmall">
        <Strong>
          <Secondary>{t('Last 90 days')}</Secondary>
        </Strong>{' '}
        <Secondary>{t('(updated daily)')}</Secondary>
      </Text>
      <Box
        background="neutralLight"
        borderRadius="large"
        paddingY="medium"
        paddingX="gutter"
      >
        <Stack space="medium">
          <Stack space="small">
            <Text size="small" weight="strong">
              {t('Profile views')}
            </Text>
          </Stack>
          <Inline space="none" alignY="bottom">
            <Text size="large" weight="strong">
              {viewCount}
            </Text>
            <span>&nbsp;</span>
            <Text size="small">
              <Secondary>
                {t('n employers viewed your profile', { viewCount })}
              </Secondary>
            </Text>
          </Inline>
        </Stack>
      </Box>
    </Stack>
  );
};
